import React from 'react';
import BannerCoursesTextBlock from 'src/molecules/banner/text.block.courses';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import {
  BannerContainer,
  BannerContainerProps,
  BannerImageContainer,
  FluidImageContainer
} from './banner.courses.styles';
import BannerCoursesConfetti from './banner.courses.confetti';

interface BannerCoursesProps extends BannerContainerProps {
  title: string;
  description: string;
  actionLink: {
    url: string;
    text: string;
    caption?: string;
  }
  actionButton: {
    text: string;
    onClick: () => void;
  }
  gatsbyImageData: IGatsbyImageData;
}

const BannerCourses = (props: BannerCoursesProps): JSX.Element => {
  return (
    <BannerContainer textPosition={props.textPosition}>
      <BannerCoursesTextBlock
        title={props.title}
        description={props.description}
        actionLink={props.actionLink}
        actionButton={props.actionButton}
      />
      <BannerImageContainer>
        <BannerCoursesConfetti />
        <FluidImageContainer>
          <GatsbyImage image={props.gatsbyImageData} alt="" objectFit="contain" />
        </FluidImageContainer>
      </BannerImageContainer>
    </BannerContainer>
  )
}

export default BannerCourses;
